import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { mtModulesRoute } from "client/parts/routes"
import { MtModule } from "server/models"
import { StateType, deepCopy } from "client/utils"
import {
    StoreType,
    ModuleList,
    ModuleFilters,
    LoadAllModules,
    SortModules,
    ChangeModuleStatus,
    setModuleList,
    setModuleIds,
    setModuleSort,
    setModuleFilters,
    addModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    Button,
    Table,
    TableSearchWrapper,
    SortRows,
    ChangeStatus,
} from "client/components"

import ModuleSearch from "client/pages/search/moduleSearch"
import Columns from "./columns"

const List = () => {
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const moduleIds = useSelector((state: StoreType) => state.module.moduleIds)
    const sortColumn = useSelector((state: StoreType) => state.module.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.module.sortOrder)
    const filters = useSelector((state: StoreType) => state.module.filters)
    const reloadList = useSelector((state: StoreType) => state.module.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAllModules().then((res) => {
            dispatch(setModuleList(res))
            setLoadState(IDLE)
        })
    }, [reloadList])

    useEffect(() => {
        const sortedIds = SortModules(Object.values(moduleList), sortColumn, sortOrder, filters)
        dispatch(setModuleIds(sortedIds))
    }, [moduleList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtModule, order) => {
        dispatch(setModuleSort(column, order))
    }

    const onFilter = (newFilters: ModuleFilters) => {
        dispatch(setModuleFilters(newFilters))
    }

    const onStatusChange: ChangeStatus = (module: MtModule, callback) => {
        ChangeModuleStatus(module).then((status) => {
            callback(() => {
                const moduleListCopy: ModuleList = deepCopy(moduleList)
                moduleListCopy[module.id] = {
                    ...moduleListCopy[module.id],
                    status,
                }
                dispatch(setModuleList(moduleListCopy))
            })
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.modules}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <TableSearchWrapper>
                    <ModuleSearch
                        id="moduleList"
                        rightOffset
                        filters={filters}
                        onFilter={onFilter}
                    />
                    <Button
                        variant="success"
                        onClick={() => dispatch(addModal({ url: `${mtModulesRoute}/${EDIT}/0` }))}
                    >
                        {lang.add}
                    </Button>
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={moduleList}
                    dataIds={moduleIds}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="md"
                    showPagination
                    onSort={onSort}
                    onStatusChange={onStatusChange}
                />
            </PageContent>
        </Container>
    )
}
export default List
